import { ref } from 'vue'
import { defineStore } from 'pinia'
import { apiClient } from '@/api/client'

export interface MenuNode {
  id: number
  label: string
  icon?: string
  isLegacy: boolean
  url?: string
  /** Vue Router path (spring_route in funzioni_2). Presente anche quando isLegacy=true. */
  springRoute?: string
  /** true = voce passata di recente al portale nuovo (badge "Nuovo" per i primi giorni). */
  nuova?: boolean
  children?: MenuNode[]
}

export const useMenuStore = defineStore('menu', () => {
  const items = ref<MenuNode[]>([])
  const loaded = ref(false)
  // Menu Utente (dropdown profilo): voci self-service figlie del nodo funzioni_2 "Menu Utente"
  // (buste paga, documenti, timbrature, ferie/permessi, rimborso KM). Rese in AppMenuProfile.
  const userItems = ref<MenuNode[]>([])

  async function loadMenu() {
    try {
      const res = await apiClient.get<MenuNode[]>('/api/v2/menu')
      items.value = res.data
    } catch {
      // menu vuoto in caso di errore — l'app rimane funzionante con il fallback
    } finally {
      loaded.value = true
    }
  }

  async function loadUserMenu() {
    try {
      const res = await apiClient.get<MenuNode[]>('/api/v2/menu/utente')
      userItems.value = res.data
    } catch {
      // dropdown profilo senza voci extra in caso di errore — resta comunque il logout
      userItems.value = []
    }
  }

  return { items, loaded, userItems, loadMenu, loadUserMenu }
})
